var exports = {
  "QV": "verticalMenu-aU1nM",
  "nd": "arrowItem-aU1nM",
  "K2": "next-aU1nM",
  "YL": "prev-aU1nM",
  "e1": "jobinfoPane-aU1nM",
};

module.exports = exports;
